import { render, staticRenderFns } from "./OnboardingWelcomeDescription.vue?vue&type=template&id=db0b4836&scoped=true&lang=pug"
import script from "./OnboardingWelcomeDescription.vue?vue&type=script&lang=ts"
export * from "./OnboardingWelcomeDescription.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingWelcomeDescription.vue?vue&type=style&index=0&id=db0b4836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b4836",
  null
  
)

export default component.exports